module.exports = __webpack_public_path__ + "static/media/main-bird-normal.b67dfde8.png";